import React from 'react';
import { Flag } from 'semantic-ui-react';
import { Card } from './Card';

export const CardPlace = ({ data, id }) => {

  if(!data.address) {
    return (<React.Fragment></React.Fragment>);
  }

  const header = (
    <React.Fragment>{data.address}</React.Fragment>
  );
  
  const meta = (
    <React.Fragment>
      <Flag name={data.country.toLowerCase()} /> {data.country_full}
    </React.Fragment>
  );


  return (
    <Card model='places' header={header} meta={meta} id={data.id} color='red' />
  )
};